import { render, staticRenderFns } from "./LanguagesOverview.vue?vue&type=template&id=e3d1daca&scoped=true&"
import script from "./LanguagesOverview.vue?vue&type=script&lang=js&"
export * from "./LanguagesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d1daca",
  null
  
)

export default component.exports